import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import DemoSwitcher from "./components/feature/DemoSwitcher";
import AccountGuard from "./components/feature/AccountGuard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AccountGuard />
        <AppRoutes />
      </BrowserRouter>
      <DemoSwitcher />
    </AuthProvider>
  );
}

export default App;